import React from 'react';
import { useTranslation } from 'react-i18next';

const MaterialPrepTaskInterface = ({ task, onTaskAction, onComplete, readOnly = false }) => {
  const { t } = useTranslation('operator');
  // Simplified state for basic task completion

  const handleCompletePreparation = () => {
    onComplete({
      taskId: task.task_id,
      completedAt: new Date().toISOString()
    });
  };

  return (
    <div className="material-prep-interface">
      <div className="task-header">
        <h3>📋 {task.task_name}</h3>
        <div className="task-type-badge material-prep">
          {t('taskTypes.materialPrep')}
        </div>
      </div>

      <div className="task-description">
        <p>{task.task_description}</p>
        {task.instructions && (
          <div className="instructions">
            <h4>{t('labels.instructions')}</h4>
            <p>{task.instructions}</p>
          </div>
        )}
      </div>




      {/* Action Buttons */}
      {!readOnly && (
        <div className="action-section">
          <button
            className="btn btn-primary btn-lg"
            onClick={handleCompletePreparation}
          >
            ✅ {t('materialPrepTaskInterface.completePreparation')}
          </button>
        </div>
      )}

      <style jsx>{`
        .material-prep-interface {
          padding: 20px;
          background: #f8f9fa;
          border-radius: 8px;
          margin-bottom: 20px;
        }

        .task-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
          padding-bottom: 15px;
          border-bottom: 2px solid #fd7e14;
        }

        .task-header h3 {
          margin: 0;
          color: #2c3e50;
          font-size: 1.3em;
        }

        .task-type-badge.material-prep {
          background: #fd7e14;
          color: white;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 0.85em;
          font-weight: bold;
          text-transform: uppercase;
        }

        .action-section {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 30px;
          padding-top: 20px;
          border-top: 1px solid #dee2e6;
        }

        .btn {
          padding: 15px 30px;
          border: none;
          border-radius: 6px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
        }

        .btn-primary {
          background: #007bff;
          color: white;
        }

        .btn:hover:not(.disabled) {
          transform: translateY(-1px);
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }

        .btn.disabled {
          opacity: 0.6;
          cursor: not-allowed;
          background: #6c757d;
        }

        .instructions {
          background: #e3f2fd;
          padding: 15px;
          border-radius: 6px;
          margin-top: 10px;
          border-left: 4px solid #2196f3;
        }

        .instructions h4 {
          margin-top: 0;
          color: #1976d2;
        }
      `}</style>
    </div>
  );
};

export default MaterialPrepTaskInterface;